// src/services/toastService.js
import { toast } from "react-toastify";

const ToastService = {
  success: (message, options = {}) => toast.success(message, options),
  error: (message, options = {}) => toast.error(message, options),
  info: (message, options = {}) => toast.info(message, options),
  warning: (message, options = {}) => toast.warning(message, options),
  dark: (message, options = {}) => toast.dark(message, options),
};

export default ToastService;
